import {
  ADVANCED_FILTER,
  PERSONAL_FILTER,
  PURCHASE_FILTER,
} from 'Pods/SearchPage/Store/constants'

// Stands in for "no personal filter" so the My Library radio group can show All models selected.
export const ALL_MODELS = 'all_models'

export const SECTION = {
  ALL: 'all',
  GENERAL: 'general',
  MY_LIBRARY: 'my_library',
}

const generalFilters = [
  {
    value: ADVANCED_FILTER.COLLECTIONS_ONLY,
    labelKey: 'packs',
  },
  {
    value: ADVANCED_FILTER.HAS_MARMOSET,
    labelKey: 'has_marmoset',
  },
  {
    value: ADVANCED_FILTER.HAS_VIDEO,
    labelKey: 'has_video',
  },
]

const myLibraryFilters = [
  {
    value: ALL_MODELS,
    labelKey: 'all_models',
  },
  {
    value: PERSONAL_FILTER.WISH_LIST_ONLY,
    labelKey: 'wish_list_only',
  },
  {
    value: PERSONAL_FILTER.LIKED_MODELS_ONLY,
    labelKey: 'liked_models_only',
  },
]

const purchaseFilters = [
  {
    value: PURCHASE_FILTER.PURCHASED_MODELS_ONLY,
    labelKey: 'purchased_items_only',
  },
]

const buildFilters = (translate, filters) => filters.map(filter => ({
  value: filter.value,
  label: translate(`search_page.filters.advanced.${filter.labelKey}`),
}))

export const getGeneralFiltersConfig = (translate) => [{
  label: translate('search_page.filters.advanced.general_group_label'),
  filters: buildFilters(translate, generalFilters),
}]

export const getMyLibraryFiltersConfig = (translate) => [{
  label: translate('search_page.filters.advanced.my_library_group_label'),
  filters: buildFilters(translate, myLibraryFilters),
}]

export const getPurchaseFiltersConfig = (translate) => [{
  label: '',
  filters: buildFilters(translate, purchaseFilters),
}]
